module.exports = __webpack_public_path__ + "img/portugal-breast-cancer-female.515667ed.png";